<template>
  <div class="top-bar w-full px-4 md:px-6 print:hidden">
    <div class="flex w-full flex-row">
      <div class="flex shrink-0 flex-row items-center gap-4">
        <TheMobileMenu />
        <QuickAdd />
        <SearchAllComponent />
      </div>
      <div class="flex flex-1 flex-row items-center justify-end gap-x-3">
        <div class="flex items-center gap-x-3">
          <div v-if="notification" class="flex items-center gap-2">
            <NotificationIconComponent
              v-for="(notif, index) in notification"
              :icon="notif.icon"
              :count="notif.count"
              :color="notif.color"
              :key="index"
              :tooltip="notif.tooltip"
            />
          </div>
          <BaseButton
            color="secondary"
            icon="sync"
            :tooltip="$t('button.refresh')"
            size="small"
            @click="$emit('askForRefresh')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import QuickAdd from '@c/layouts/top-bar/components/QuickAdd.vue'
import TheMobileMenu from '@c/layouts/mobile-menu/TheMobileMenu.vue'
import SearchAllComponent from './components/SearchAllComponent.vue'
import NotificationIconComponent from './NotificationIconComponent.vue'

export default {
  components: {
    QuickAdd,
    TheMobileMenu,
    NotificationIconComponent,
    SearchAllComponent
  },

  emits: ['askForRefresh'],
  data() {
    return {
      breadcrumb: []
    }
  },
  computed: {
    ...mapGetters({ notification: 'notification/getNotifications' }),
    appTitle() {
      return import.meta.env.VITE_APP_NAME
    }
  },
  methods: {
    ...mapActions({ fetchNotifications: 'notification/fetchNotifications' })
  },
  watch: {
    $route(to, from) {
      this.breadcrumb = to.meta.breadcrumb
    }
  },
  mounted() {
    this.fetchNotifications()
  }
}
</script>
